import React from "react";

import { FormSectionElements } from "../../../entities/formTemplateDataType";
import { DEFAULT_PLATE_CHARACTERS, renderPlateImage } from "../../../utilities/custom/PlpUtils";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import {OrderPriceSections, PaymentArea, ProductArea} from "./OrderBreakdownComponent-style"
import './OrderBreakdownComponent.css';
import { NameValuePair } from "./models";

interface Props {
  field: FormSectionElements;
  isEng: boolean;
}

const plateImageHtml = (index: number, plateType: string, sloganLanguage: string, graphicType: string, plateCharacters?: string): React.JSX.Element => {
  const html = <>
      <div id={`plate-image-summary-` + index} style={{marginTop: '16px', marginBottom: '16px', marginRight: '76px'}}></div>
  </>;

  renderPlateImage(plateType, sloganLanguage, graphicType, plateCharacters || DEFAULT_PLATE_CHARACTERS, index);

  return html;
}

const getProductSectionTitle = (field, isEng) => {
  if (isEng) {
    return field.OrderBreakdownConfig?.productSectionTitle || "Products to check out";
  } else {
    return field.OrderBreakdownConfig?.productSectionTitleFRA || "Produits à découvrir";
  }
}

const getPaymentSectionTitle = (field, isEng) => {
  if (isEng) {
    return field.OrderBreakdownConfig?.paymentSectionTitle || "Payment summary";
  } else {
    return field.OrderBreakdownConfig?.paymentSectionTitleFRA || "Récapitulatif du paiement";
  }
}
 
const getColumnHeader1 = (field, isEng) => {
  if (isEng) {
    return field.OrderBreakdownConfig?.paymentColumn1Header || "Product";
  } else {
    return field.OrderBreakdownConfig?.paymentColumn1HeaderFRA || "Produit";
  }
}

const getColumnHeader2 = (field, isEng) => {
  if (isEng) {
    return field.OrderBreakdownConfig?.paymentColumn2Header || "Amount";
  } else {
    return field.OrderBreakdownConfig?.paymentColumn2HeaderFRA || "Montant";
  }
}

const findEntry = (list: NameValuePair[], name: string) => {
  return list.find((entry) => entry.name === name);
}

/**
 * A generic component to display the breakdown of the order in CXP format.
 * @param param0 
 * @returns 
 */
const OrderBreakdownComponent = ({field, isEng}: Props) => {
  FormValidationUtils.runJavascript(field);

  const orderBreakdown = field.Value;
  if (field.OrderBreakdownConfig?.showPlateImage) {
    let index = 0;
    orderBreakdown?.products?.map((product) => {
      product.items.map((item) => {
        if (item.additionalProperties?.length) {
          item.htmlElement = plateImageHtml(index++, findEntry(item.additionalProperties, 'plateType')?.value, findEntry(item.additionalProperties, 'sloganLanguage')?.value, findEntry(item.additionalProperties, 'graphicType')?.value, findEntry(item.additionalProperties, 'plateCharacters')?.value);
        }
      })   
    })
  }

  return (
    <>
      <OrderPriceSections>
          <ProductArea products={orderBreakdown?.products} className={'product-card'} title={getProductSectionTitle(field, isEng)} isEng={isEng} />
          <PaymentArea
              sectionTitle={getPaymentSectionTitle(field, isEng)}
              columnHeader1={getColumnHeader1(field, isEng)}
              columnHeader2={getColumnHeader2(field, isEng)}
              payment={orderBreakdown?.payment}
              className=''
              isEng={isEng}
          />
      </OrderPriceSections>
    </>
  );
}

export default OrderBreakdownComponent;